<template lang="pug">
  .table-rows(:class="classes" v-if="showTableRow")
    .table-rows__label-block(v-if="!insideMultipleRow")
      p.table-rows__label {{label}}
      p.table-rows__cdflabel(v-if="showCDF") {{cdfcode}}
    .table-rows__value-block(:class="classesMultiple" )
      .table-rows__delete-icon(v-if="newValue && challengeMode && !challengeLine" @click="cancelChallenge(field)")
        font-awesome-icon(icon="trash-alt" regular size="sm")
      .table-rows__updated-value(v-if="newValue && challengeMode"
        @click="openModal(field, true)"
        :class="updateHoverClass"
      )
        row-creator(:item="field", :value="parseValue(newValue)")
      .table-rows__current-value(
        @click="openModal(field)"
        :class="hoverClass")
        .table-rows__icon(v-if="challengeMode && !challengeLine")
          font-awesome-icon(icon="pen")
        row-creator(
          :item="field",
          :value="parseValue(value)",
          :challengeMode="challengeMode",
          :tooltip="tooltip"
          :fullList="getFullList(value)"
        )
      challenge-row(
        v-if="challengeMode && challengeLine"
        :challenge="inLineChallenge(field)"
        :parentType="parentType"
        :prerequisite="prerequisite"
        @close="closeChallenge"
      )
</template>
<script>
import { mapState, mapMutations, mapGetters, } from 'vuex'
import {
  TOGGLE_CHALLENGE_MODAL,
  SET_CHALLENGE,
  TOGGLE_CHALLENGE_EXPIRATION_MODAL,
  SET_CURRENT_RELATIONSHIP_TYPE,
  RM_FIELD,
  RM_FIELDS,
} from '@/store/modules/record/modules/challenge/mutations-types'
import { getFieldByPath, } from '@/utils/challenge'
import Challenge from '@/mixins/challenge'
import RowCreator from './RowCreator'
import ChallengeRow from './ChallengeRow'
import ChallengeIcon from '../../challenge-components/ChallengeIcon'
import { getCDF, } from '../../../utils/cdf'
import _ from 'lodash/string'


export default {
  components: {
    RowCreator,
    ChallengeIcon,
    ChallengeRow,
  },
  inject: {
    isSeparated: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [ Challenge, ],
  props: {
    parentType: {
      type: [ Object, Boolean, ],
      default: false,
    },
    disabledRow: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [ Object, Array, ],
      required: true,
    },
    insideMultipleRow: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      field: {},
      challengeLine: false,
    }
  },
  computed: {
    classes () {
      return {
        'table-rows__challenge': this.challengeMode && !this.isMultiplyField && !this.disabled && !this.deprecated,
        'table-rows__disabled': this.challengeMode && this.disabled,
        'table-rows__disabled-field': this.challengeMode && this.disableField,
        'table-rows__indented': this.indented,
        'table-rows__changed-row': this.changed,
        'table-rows__without-indented': this.isMultiplyField,
        'table-rows__inside-multiple-row': this.insideMultipleRow,
        'table-rows__deprecated': this.deprecated,
      }
    },
    hoverClass () {
      return {
        'table-rows__hover': !this.challengeLine && this.isInline && !this.disableField && !this.newValue,
      }
    },
    updateHoverClass () {
      return {
        'table-rows__hover-updated': !this.challengeLine && this.isInline && this.newValue && !this.disableField,
      }
    },
    classesMultiple () {
      return {
        'table-rows__hover-details': this.isDetailModal,
      }
    },
    changed () {
      return !!this.newValue
    },
    label () {
      return this.field.label
    },
    value () {
      return this.field.value
    },
    tooltip () {
      return !!this.field.tooltip
    },
    jsonPath () {
      if (!this.item.jsonPath) return this.item.jsonPath
      return this.item.jsonPath.replace(/\[(.+?)]/g, '[*]')
    },
    rawJsonPath () {
      return this.item.jsonPath
    },
    disabled () {
      return this.field.disabled
    },
    prerequisite () {
      if (this.item.prerequisite) {
        const validationPath = this.rawJsonPath.replace('.validatedAs', '.validatedAt')
        const prerequisiteData = this.getSavedFieldByPath(`${validationPath}.id`)
            || this.getSavedFieldByPath(`${validationPath}.other`)
        return !prerequisiteData ? 'Other Validation Authority Data Validated At is required' : false
      }
      return this.parentType ? this.parentType.updatedParentType !== this.item.type : this.parentType
    },
    disableField () {
      return this.parentType ?
        this.parentType.updatedParentType !== this.parentType.currentParentType
          && this.parentType.updatedParentType !== this.item.type
        : this.parentType
    },
    currentType () {
      return this.parentType ? this.parentType.currentParentType : this.parentType
    },
    indented () {
      return this.field.indented
    },
    deprecated () {
      return this.field.isDeprecated
    },
    isExpiration () {
      return this.field.isExpiration
    },
    isMultiplyField () {
      return Boolean(this.field.multiple && this.value)
    },
    isInline () {
      return this.field.inline
    },
    isDetailModal () {
      return this.field.detailModal
    },
    link () {
      return this.field.link || null
    },
    getValue () {
      return this.field.getValue
    },
    newValue () {
      return this.rawJsonPath === '$.entity.expiration'
        ? this.getValueForExpiration()
        : this.getSavedFieldByPath(this.rawJsonPath)
    },
    showTableRow () {
      return this.showEmptyFields || !this.isEmpty(this.value)
    },
    cdfcode () {
      return getCDF(this.jsonPath, this.filters)
    },

    ...mapState('record', [ 'showEmptyFields', 'showCDF', ]),
    ...mapState('record/challenge', [ 'fields', ]),
    ...mapState('search', [ 'filters', ]),
    ...mapGetters('record/challenge', [ 'getSavedFieldByPath', ]),
  },
  watch: {
    disableField () {
      this.composeField()
    },
    prerequisite (){
      this.composeField()
    },
  },
  created () {
    this.composeField()
  },
  methods: {
    composeField () {
      const field = getFieldByPath(this.jsonPath)
      this.field = field ? {
        ...this.item,
        ...field,
        jsonPath: this.rawJsonPath,
        prerequisite: this.prerequisite,
        disableField: this.disableField,
      } : { ...this.item, }
    },
    inLineChallenge (item) {
      return {
        ...item,
        title: item.label,
        oldValue: this.jsonPath === '$.entity.successorEntities[*].lei' ?
          `${item.value.lei} ${item.value.name}` : item.value,
      }
    },
    getValueForExpiration () {
      const date = this.getSavedFieldByPath(`${this.rawJsonPath}.date`)
      const reason = this.getSavedFieldByPath(`${this.rawJsonPath}.reason`)
      return date || reason ? {
        date,
        reason,
      } : null
    },
    parseValue (val) {
      return this.getValue ? this.getValue(val) : val
    },
    getFullList (val) {
      if (!val) return null
      if (Array.isArray(val.firstFive) && val.meta.pagination.total > 5) {
        return val
      }
      return null
    },
    isEmpty (value) {
      const noValue = !value || value === ''
      const emptyArr = Array.isArray(value) && !value.length
      const emptyArrValue = Array.isArray(value) && !value.some((val) => typeof val === 'object' ? !!val.value : true)
      const emptyMapping = value && value.firstFive && !value.firstFive.length
      return noValue || emptyArr || emptyMapping || emptyArrValue
    },
    closeChallenge () {
      this.challengeLine = false
    },
    openModal (item, updated) {
      if (this.disabledRow && this.disabled) return
      if (this.newValue && !updated) return
      if (this.isMultiplyField || this.isDetailModal || this.disableField) return
      if (this.isInline && this.challengeMode) {
        this.challengeLine = true
      }
      else if (this.challengeMode && !this.disabled && this.isSeparated && !this.deprecated) {
        this.setChallenge({
          ...item,
          title: item.label,
          oldValue: this.jsonPath === '$.entity.successorEntities[*].lei' ?
            `${item.value.lei} ${item.value.name}` : item.value,
        })
        this.isExpiration ? this.toggleChallengeExpirationModal() : this.toggleChallengeModal()
      }
    },
    cancelChallenge (item) {
      if (this.item.masterField === 'parentEntity' && (this.currentType === 'exception' || this.currentType === 'nonExisting' || this.disableField)) {
        this.$confirm(`Do you want to cancel ${_.startCase(this.parentType.parent)} Entity challenge`, {
          type: 'warning',
        }).then(() => {
          this.removeFields(this.parentType.parent)
          this.setCurrentRelationshipType({
            parentType: this.parentType.parent,
            relationshipType: this.currentType,
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Challenge continues',
          })
        })

      } else if (this.item.masterField === 'reason' && this.currentType === 'parent') {
        this.$confirm(`Do you want to cancel ${_.startCase(this.parentType.parent)} Exception challenge?`, {
          type: 'warning',
        }).then(() => {
          this.removeFields(this.parentType.parent)
          this.setCurrentRelationshipType({
            parentType: this.parentType.parent,
            relationshipType: this.currentType,
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Challenge continues',
          })
        })
      } else {
        this.removeField(item.jsonPath)
      }
    },

    ...mapMutations('record/challenge', {
      toggleChallengeModal: TOGGLE_CHALLENGE_MODAL,
      toggleChallengeExpirationModal: TOGGLE_CHALLENGE_EXPIRATION_MODAL,
      setChallenge: SET_CHALLENGE,
      setCurrentRelationshipType: SET_CURRENT_RELATIONSHIP_TYPE,
      removeField: RM_FIELD,
      removeFields: RM_FIELDS,

    }),
  },
}
</script>
<style lang="stylus">
  @import "../../../assets/styles/variables.styl"

  .table-rows
    display flex
    width 100%
    font-size 95%
    min-height 45px
    justify-content space-between



    &__label-block, &__value-block
        line-height 1.5
        display flex
        position relative

    &__label-block
      flex-direction column
      align-items flex-end
      justify-content flex-start
      width 20%
      min-width 320px
      margin-right 5px
      margin-bottom 2px
      text-align right
      padding 15px 20px
      background-color $default-color-light-2
      color $default-color

    &__icon
      display none
      background $white-color
      border-radius 50%
      border 1px solid $primary-hover
      box-shadow 1px 4px 6px -2px rgba(0,0,0,0.69)
      height 35px
      width 35px
      justify-content center
      align-content center
      position absolute
      top 50%
      right -15px
      transform: translateY(-50%);
      padding-top 8px

    &__delete-icon
      position absolute
      height 24px
      width 24px
      justify-content center
      display flex
      z-index 2
      color $primary-color
      background $primary-color-light-2
      border-radius 50%
      border 1px solid $primary-color
      align-items center
      top -11px
      right -11px
      &:hover
        background $primary-color
        color $primary-color-light-2


    &__cdflabel
      font-size 13px
      max-width 200px

    &__label
      font-weight 700

    &__value-block
      align-items center
      flex-direction column
      width 80%
      padding-bottom 2px
      margin-left 5px
      text-align left
      justify-content flex-start
      flex 1

    &__current-value
      width 100%
      height 100%
      padding 12px 17px
      background-color $default-color-light-2
      border 3px solid $default-color-light-2
      position relative
    &__updated-value
      width 100%
      height 100%
      z-index 1
      position relative
      background-color $warning-color-light-2
      border-right 5px solid $warning-color
      padding 15px 20px



    &__indented
      margin-top 15px

    &__disabled
      .table-rows__label-block
        background-color $disabled-bg
        color $disabled-color

      .table-rows__current-value
        cursor not-allowed
        background-color $disabled-bg
        border-color $disabled-bg
        color $disabled-color !important
      .value
        color $disabled-color !important

    &__disabled-field
      .table-rows__label-block
        color $disabled-color

      .table-rows__current-value
        cursor not-allowed
        color $disabled-color !important

      .value
        color $disabled-color !important

    &__deprecated
      .table-rows__label-block
        background-color $deprecated-bg
        color $disabled-color

      .table-rows__current-value
        cursor not-allowed
        background-color $deprecated-bg
        border-color $deprecated-bg
        color $disabled-color !important


    &__without-indented
      .table-rows__label-block
        padding: 15px 20px

      .table-rows__current-value
        padding: 0
      .table-rows__current-value
        border none

    &__inside-multiple-row
      &:nth-of-type(2n + 3)
        border-top 2px solid white
      .table-rows__label-block
          display none
      .table-rows__value-block
          margin-left 0

      .table-rows__current-value
        padding 12px 17px
        background-color $default-color-light-2
        border 3px solid $default-color-light-2
        margin-left 0

    &__challenge
      .table-rows__hover:hover
        cursor pointer
        background-color $primary-hover
        border 3px solid $primary-color
        .table-rows__icon
          display flex
      .table-rows__hover-updated:hover
        cursor pointer
        background-color $warning-color-light-1


@media (max-width: $laptop)
  .table-rows
    &__label-block
      width 15%
      min-width 250px
    &__value-block
      width 85%

@media (max-width: $tablet)
  .table-rows
    margin-bottom 0
    border-bottom none
    font-size 90%
    border-bottom 1px solid $default-color-light-1
    padding 5px 10px
    flex-direction column

    &__without-indented
      padding: 0
      .table-rows__label-block
        padding 10px 20px 5px
      .table-rows__value-block
        padding 5px 20px 10px


    &__label-block, &__value-block
      justify-content flex-start
      align-items flex-start
      padding 5px 10px
      background-color transparent
      width 100%
      min-width auto
      margin 0
      text-align left

    &__current-value
      padding 0
      background-color transparent
      border none

    &__updated-value
      padding 5px 0 5px 10px
      margin-left -10px
      margin-bottom 5px

    &__delete-icon
      top -10px
      right 10px

    &__icon
      padding-top 7px
      height 30px
      width 30px

    &__label
        color $default-color-middle
        font-weight 600

    &__deprecated
      .table-rows__label-block, .table-rows__value-block
        background-color $deprecated-bg

    &__disabled,
    &__disabled-field
      .table-rows__label-block, .table-rows__value-block
        background-color $disabled-bg

    &__inside-multiple-row
      padding 0
      border none
      min-height 25px

      .table-rows__value-block
        padding 0

      .table-rows__delete-icon
        right 0

      .table-rows__current-value
        border none
        background-color transparent
        padding 0

    &__challenge
      .table-rows__hover:hover
        background-color transparent
        border none


</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/TableRow.vue